/**
 * article模块接口列表
 */

import base from './base'; // 导入接口域名列表
import axios from '@/axios/request'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块

const article = {
    // footer-menu
    getGoodsMenu(params) {
        //https://www.fotile.com/h5/headerInfo/headerInfo
        return axios.get(`https://www.fotile.com/h5/headerInfo/headerInfo`, {
            params: params
        });
    },
}

export default article;